import { Navigate } from 'react-router-dom';

export default function AdminIndexPage() {
  return <Navigate to="/admin/clientes" replace />;
}
